import { FunctionComponent, useCallback } from 'react'
import styled, { css } from 'styled-components'

import { type Image } from '@utils/cook/types'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'

import useFeatureFlagsSkeleton from '@hooks/useFeatureFlagsSkeleton'

import FollowMyTeamOverviewBanner from '@components/FollowMyTeamOverview/FollowMyTeamOverviewBanner'
import { mobileCSS } from '@measures/responsive'

export interface FollowMyTeamOverviewAPIProps {
  title: string
  backgroundImage: Image<'16_9'>
  image: Image<'free'>
}

const FollowMyTeamOverviewWrapper = styled.div`
  height: 80px;

  ${mobileCSS(css`
    height: 64px;
  `)};
`

const FollowMyTeamOverview: FunctionComponent<FollowMyTeamOverviewAPIProps> = (
  props
) => {
  const { title, backgroundImage, image } = props
  const { isFollowMyTeamEnabled } = useFeatureFlagsSkeleton()

  const handleBannerClick = useCallback(() => {
    console.log('banner clicked')
  }, [])

  if (!isFollowMyTeamEnabled) {
    return null
  }

  return (
    <FollowMyTeamOverviewWrapper>
      <FollowMyTeamOverviewBanner
        backgroundImage={backgroundImage}
        image={image}
        title={title}
        onClick={handleBannerClick}
      />
    </FollowMyTeamOverviewWrapper>
  )
}

const widget = {
  kind: ['follow-my-team-overview'],
  component: FollowMyTeamOverview,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
